/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// Applies runtime overrides from window.APP_ENV (set by /assets/env.js) to the
// imported environment object. Side-effect import — must run first so the
// mutation lands before AppModule's transitive imports evaluate any
// module-level `environment.X` reads.
import './environments/environment.merged';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
